import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { OidcClientService } from '@upmc-healthplan-npm/oidc-client';
import { Observable, mergeMap } from 'rxjs';

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {
  private oidc: OidcClientService = inject(OidcClientService);

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (req.headers.has('Authorization')) {
      return next.handle(req);
    } else {
      return new Observable<HttpRequest<any>>((observer) => {
        this.oidc.getUserComputed().subscribe({
          next: (user) => {
            if (user) {
            } else {
              this.oidc.signIn();
            }
            let newRequest;
            if (!req.headers.has('Authorization')) {
              newRequest = req.clone({
                setHeaders: { Authorization: `Bearer ${user.id_token}` },
              });
            } else {
              newRequest = req;
            }
            this.oidc.renewToken();
            observer.next(newRequest);
            observer.complete();
          },
        });
      }).pipe(mergeMap((req: HttpRequest<any>) => next.handle(req)));
    }
  }
}
